<app-guest-toppage-desktop *ngIf="isDesktopMode()" [property]="property" [booking]="booking" ></app-guest-toppage-desktop>
